<div class="container" [ngClass.xs]="'extra-small-container'">
    <div class="header-container">
        <div class="header-column-one" fxFlex = "28%">
            <h3 class="title">Date</h3>
        </div>
        <div class = "header-column-two"  fxFlex = "36%">
            <h3 class="title">Title and Description</h3>
        </div>
        <div class = "header-column-three"  fxFlex = "20%">
            <h3 class="title">Location</h3>
        </div>
        <div class= "header-column-four">
            <h3 class="title">Type</h3>
        </div>
    </div>
    <!-- <ng-scrollbar #scrollable track="all" pointerEventsMethod="scrollbar" [disabled]="disabled"> -->
        
    <div class="content-container" [ngClass.xs] = "'extra-small-content-container'">
        <mat-card appearance="outlined" class="card-container">
            <mat-list >
                <mat-list-item>
                    <div class="list-column-one" fxFlex = "25%">
                        <div [ngClass.xs]="'extra-small-scr-list-col-one-inner-container'">
                            <mat-icon [ngClass.xs] = "'extra-small-scr-circle-icon'">check_circle_outline</mat-icon>
                        </div>
                        <div>
                            <h3 [ngClass.xs] = "'extra-small-scr-date'">{{currentDate}}</h3>
                            <h3 [ngClass.xs] = "'extra-small-scr-time'">&#64; 2:00PM</h3>
                            <button mat-raised-button class="start" [ngStyle.xs] = "">START</button>
                        </div>
                    </div>
                    <div class="list-column-two" fxFlex = "40%">
                        <div>
                            <h3 class="list-title" [ngClass.xs] = "'extra-small-scr-list-title'">Agora UI Discussion</h3>
                        </div>
                        <div>
                            <ul class = "list-container" *ngIf = "deviceLg || deviceXl">
                                <li class = "list-item-container" [ngClass.xs] = "'extra-small-scr-list-itm-container'">Lakhmi kala M</li>
                                <li class = "list-item-container" [ngClass.xs] = "'extra-small-scr-list-itm-container'">Shivakumar M</li>
                                <li class = "list-item-container" [ngClass.xs] = "'extra-small-scr-list-itm-container'">Chandrasekar K</li>
                                <li class = "list-item-container" [ngClass.xs] = "'extra-small-scr-list-itm-container'">3 more...</li>
                            </ul>
                            <ul class = "list-container" *ngIf = "deviceXs || deviceMd">
                                <li class = "list-item-container" [ngClass.xs] = "'extra-small-scr-list-itm-container'">Lakhmi kala M</li>
                                <li class = "list-item-container" [ngClass.xs] = "'extra-small-scr-list-itm-container'">3 more...</li>
                            </ul>
                        </div>
                        <div>
                            <h3 [ngClass.xs] = "'extra-small-agenda-section'">Agenda - 1: Description</h3>
                        </div>
                    </div>
                    <div class="list-column-three" fxFlex = "27%">
                        <h3 [ngClass.xs] = "'extra-small-scr-list-col-content'">RC - 148 148 4949</h3>
                    </div>
                    <div class="list-column-four" fxFlex = "11%">
                        <h3 [ngClass.xs] = "'extra-small-scr-list-col-four-content'">Follow Up</h3>
                        <mat-icon [ngClass.xs] = "'extra-small-vert-icon'">more_vert</mat-icon>
                    </div>
                </mat-list-item>
            </mat-list>
        </mat-card>
        <div>
            <app-pagination></app-pagination>
        </div>
    </div>
<!-- </ng-scrollbar> -->
        
</div>